(function () {
  'use strict';

  var PRODUCTS = Array.isArray(window.BCA_SEARCH_INDEX) ? window.BCA_SEARCH_INDEX : [];
  var STOP_WORDS = new Set(['el','la','los','las','un','una','unos','unas','de','del','para','por','con','y','o','en']);
  var GENERIC_WORDS = new Set(['camiseta','camisetas','cobija','cobijas','diseno','disenos','producto','productos','anime','bacanime']);
  var TOKEN_ALIASES = {
    iorn:'iron',
    jami:'jamiroquai',
    jamiroquai:'jamiroquai',
    sync:'nsync',
    nsync:'nsync',
    soad:'system of a down',
    soaf:'system of a down',
    gocu:'goku',
    harri:'harry',
    poter:'potter',
    potter:'potter',
    anilos:'anillos',
    anilo:'anillo',
    dragonball:'dragon ball',
    harrypoter:'harry potter',
    shingeki:'shingeki',
    senfold:'sevenfold',
    kimetsu:'kimetsu'
  };
  var QUERY_ALIASES = {
    gocu:'dragon ball',
    goco:'dragon ball',
    goko:'dragon ball',
    gokuu:'dragon ball',
    goku:'dragon ball',
    esdla:'senor anillos',
    lotr:'senor anillos',
    'el senor':'senor anillos',
    dbz:'dragon ball z',
    dragonball:'dragon ball',
    hp:'harry potter',
    harrypoter:'harry potter',
    snk:'shingeki kyojin',
    aot:'attack titan',
    mha:'boku hero',
    bnha:'boku hero',
    kimetsu:'demon slayer',
    acdc:'ac dc', adcd:'ac dc',
    gunsnroses:'guns roses'
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' y ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function words(value) {
    var normalized = normalize(value);
    return normalized ? normalized.split(' ') : [];
  }

  var VOCABULARY = new Map();
  function prepareProduct(product) {
    var title = normalize(product.t);
    var type = normalize(product.y);
    var tags = normalize((product.g || []).join(' '));
    var titleWords = words(title);
    var tagWords = words(tags);
    titleWords.concat(tagWords).forEach(function (word) {
      if (word.length < 3 || STOP_WORDS.has(word) || GENERIC_WORDS.has(word)) return;
      VOCABULARY.set(word, (VOCABULARY.get(word) || 0) + 1);
    });
    return {
      product: product,
      title: title,
      type: type,
      tags: tags,
      titleWords: titleWords,
      tagWords: tagWords
    };
  }
  var PREPARED_PRODUCTS = PRODUCTS.map(prepareProduct);
  var PREPARED_BY_HANDLE = new Map(PREPARED_PRODUCTS.map(function (item) {
    return [item.product.h, item];
  }));
  var VOCAB_WORDS = Array.from(VOCABULARY.keys());

  function updateCatalog(products) {
    PRODUCTS = products;
    VOCABULARY.clear();
    PREPARED_PRODUCTS = PRODUCTS.map(prepareProduct);
    PREPARED_BY_HANDLE = new Map(PREPARED_PRODUCTS.map(function(item){return [item.product.h,item];}));
    VOCAB_WORDS = Array.from(VOCABULARY.keys());
    correctionCache.clear();
  }

  function damerauLevenshtein(a, b) {
    var al = a.length;
    var bl = b.length;
    var matrix = Array.from({ length: al + 1 }, function () {
      return new Array(bl + 1).fill(0);
    });
    var i;
    var j;
    for (i = 0; i <= al; i += 1) matrix[i][0] = i;
    for (j = 0; j <= bl; j += 1) matrix[0][j] = j;
    for (i = 1; i <= al; i += 1) {
      for (j = 1; j <= bl; j += 1) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j - 1] + cost
        );
        if (
          i > 1 &&
          j > 1 &&
          a[i - 1] === b[j - 2] &&
          a[i - 2] === b[j - 1]
        ) {
          matrix[i][j] = Math.min(matrix[i][j], matrix[i - 2][j - 2] + cost);
        }
      }
    }
    return matrix[al][bl];
  }

  function maxDistance(word) {
    if (word.length <= 4) return 1;
    if (word.length <= 7) return 1;
    return 2;
  }

  var correctionCache = new Map();
  function bestCorrection(token) {
    if (correctionCache.has(token)) return correctionCache.get(token);
    var result = calculateCorrection(token);
    if (correctionCache.size >= 100) correctionCache.clear();
    correctionCache.set(token, result);
    return result;
  }

  function calculateCorrection(token) {
    if (TOKEN_ALIASES[token]) {
      return { value: TOKEN_ALIASES[token], changed: TOKEN_ALIASES[token] !== token, reason: 'alias' };
    }
    if (VOCABULARY.has(token)) return { value: token, changed: false, reason: 'exact' };
    if (token.length < 3) return { value: token, changed: false, reason: 'short' };

    if (token.length >= 3) {
      var prefixCandidates = VOCAB_WORDS
        .filter(function (candidate) { return candidate.indexOf(token) === 0; })
        .sort(function (a, b) {
          var frequency = (VOCABULARY.get(b) || 0) - (VOCABULARY.get(a) || 0);
          return frequency || (a.length - b.length) || a.localeCompare(b);
        });
      if (prefixCandidates.length) {
        if (prefixCandidates.length === 1) {
          return {
            value: prefixCandidates[0],
            changed: prefixCandidates[0] !== token,
            reason: 'prefix',
            alternatives: prefixCandidates
          };
        }
        return {
          value: token,
          changed: false,
          reason: 'prefix-many',
          alternatives: prefixCandidates.slice(0, 3)
        };
      }
    }

    if (token.length <= 4) return { value: token, changed: false, reason: 'short-ambiguous' };

    var allowed = maxDistance(token);
    var candidates = [];
    VOCAB_WORDS.forEach(function (candidate) {

      if (Math.abs(candidate.length - token.length) > allowed) return;
      var distance = damerauLevenshtein(token, candidate);
      if (distance <= allowed) {
        candidates.push({
          value: candidate,
          distance: distance,
          frequency: VOCABULARY.get(candidate) || 0
        });
      }
    });
    candidates.sort(function (a, b) {
      return a.distance - b.distance || b.frequency - a.frequency || a.value.localeCompare(b.value);
    });
    if (!candidates.length) return { value: token, changed: false, reason: 'none' };

    var top = candidates[0];
    var second = candidates[1];
    if (
      second &&
      second.distance === top.distance &&
      second.frequency === top.frequency &&
      second.value !== top.value
    ) {
      return { value: token, changed: false, reason: 'ambiguous' };
    }
    return { value: top.value, changed: top.value !== token, reason: 'fuzzy' };
  }

  function resolveQuery(rawValue) {
    var raw = normalize(rawValue);
    if (!raw) return { raw: '', query: '', changed: false, optimized: false, notice: false, tokens: [] };

    if (QUERY_ALIASES[raw]) {
      return {
        raw: raw,
        query: QUERY_ALIASES[raw],
        changed: QUERY_ALIASES[raw] !== raw,
        optimized: true,
        notice: true,
        tokens: words(QUERY_ALIASES[raw])
      };
    }

    var originalTokens = words(raw);
    var meaningfulTokens = originalTokens.filter(function (token) { return !STOP_WORDS.has(token); });
    if (!meaningfulTokens.length) meaningfulTokens = originalTokens.slice();

    var corrected = meaningfulTokens.map(bestCorrection);
    var queryTokens = corrected.reduce(function (all, item) { return all.concat(words(item.value)); }, []);
    var query = queryTokens.join(' ');
    // Do not "correct" half of an unknown artist into an unrelated catalogue name.
    // A fuzzy suggestion must describe a complete product title in the vocabulary.
    if (corrected.some(function (item) { return item.reason === 'fuzzy'; }) &&
        !PREPARED_PRODUCTS.some(function (product) { return titleMatchesQuery(product.title, query); })) {
      corrected = corrected.map(function (item, index) {
        return item.reason === 'fuzzy' ? { value: meaningfulTokens[index], changed: false, reason: 'unverified' } : item;
      });
      queryTokens = corrected.reduce(function (all, item) { return all.concat(words(item.value)); }, []);
      query = queryTokens.join(' ');
    }
    var changed = corrected.some(function (item) { return item.changed; });
    var removedStopWords = meaningfulTokens.length !== originalTokens.length;
    var alternatives = [];

    corrected.forEach(function (item, index) {
      if (!Array.isArray(item.alternatives)) return;

      item.alternatives.forEach(function (candidate) {
        var alternative = corrected.map(function (entry, entryIndex) {
          return entryIndex === index ? candidate : entry.value;
        }).join(' ');

        alternative = normalize(alternative);
        if (alternative && alternative !== query && alternatives.indexOf(alternative) === -1) {
          alternatives.push(alternative);
        }
      });
    });

    return {
      raw: raw,
      query: query || raw,
      changed: changed,
      optimized: changed || removedStopWords,
      notice: changed,
      tokens: queryTokens,
      alternatives: alternatives.slice(0, 3),
      reasons: corrected.map(function (item) { return item.reason; })
    };
  }

  function scorePrepared(prepared, resolved) {
    var query = resolved.query;
    var tokens = resolved.tokens;
    if (!query || !tokens.length) return 0;
    var score = 0;

    if (prepared.title === query) score += 140;
    else if (prepared.title.indexOf(query) !== -1) score += 80;
    if (prepared.tags.indexOf(query) !== -1) score += 36;

    tokens.forEach(function (token) {
      if (prepared.titleWords.indexOf(token) !== -1) score += 28;
      else if (prepared.titleWords.some(function (word) { return word.indexOf(token) === 0; })) score += 20;
      else if (prepared.title.indexOf(token) !== -1) score += 13;

      if (prepared.tagWords.indexOf(token) !== -1) score += 11;
      else if (prepared.tagWords.some(function (word) { return word.indexOf(token) === 0; })) score += 7;
      if (prepared.type.indexOf(token) !== -1) score += 4;
    });

    var allTokensFound = tokens.every(function (token) {
      return prepared.title.indexOf(token) !== -1 || prepared.tags.indexOf(token) !== -1;
    });
    if (allTokensFound) score += 45;
    return score;
  }

  function scorePreparedLoose(prepared, resolved, strictScore) {
    if (!prepared || !resolved) return strictScore || 0;

    var queryTokens = words(resolved.raw).concat(resolved.tokens || []);
    var productTokens = prepared.titleWords.concat(prepared.tagWords);
    var bestSimilarity = 0;

    queryTokens.forEach(function (token) {
      if (token.length < 3 || STOP_WORDS.has(token) || GENERIC_WORDS.has(token)) return;

      productTokens.forEach(function (candidate) {
        if (
          candidate.length < 3 ||
          candidate[0] !== token[0] ||
          STOP_WORDS.has(candidate) ||
          GENERIC_WORDS.has(candidate)
        ) {
          return;
        }

        if (candidate === token) {
          bestSimilarity = Math.max(bestSimilarity, 34);
          return;
        }

        if (candidate.indexOf(token) === 0 || token.indexOf(candidate) === 0) {
          bestSimilarity = Math.max(bestSimilarity, 26);
          return;
        }

        var allowed = Math.min(2, maxDistance(token) + 1);
        if (Math.abs(candidate.length - token.length) > allowed) return;
        var distance = damerauLevenshtein(token, candidate);
        if (distance <= allowed) {
          bestSimilarity = Math.max(bestSimilarity, 26 - (distance * 7));
        }
      });
    });

    return (strictScore || 0) + bestSimilarity;
  }

  function rankProducts(resolved, limit) {
    return PREPARED_PRODUCTS
      .map(function (prepared) {
        return { prepared: prepared, score: scorePrepared(prepared, resolved) };
      })
      .filter(function (item) { return item.score > 0; })
      .sort(function (a, b) {
        return b.score - a.score || a.prepared.title.localeCompare(b.prepared.title);
      })
      .slice(0, limit || 6);
  }

  function ensureHidden(form, name, value) {
    var field = form.querySelector('input[name="' + name.replace(/"/g, '\\"') + '"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
  }

  function prepareForm(form) {
    var q = form.querySelector('input[name="q"]');
    if (!q) return;
    ensureHidden(form, 'type', 'product');
    ensureHidden(form, 'options[prefix]', 'last');
  }

  function searchUrl(query, original, notice) {
    var url = new URL('/search', window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('bca_smart', '1');
    if (original) url.searchParams.set('bca_original', original);
    if (notice) url.searchParams.set('bca_notice', '1');
    return url.pathname + '?' + url.searchParams.toString();
  }

  function requiresNativeValidation(resolved) {
    return Array.isArray(resolved.reasons) && resolved.reasons.indexOf('fuzzy') !== -1;
  }

  function isLowConfidence(resolved) {
    if (!resolved || !Array.isArray(resolved.reasons)) return false;

    return resolved.reasons.some(function (reason) {
      return reason === 'fuzzy' || reason === 'ambiguous' || reason === 'none';
    });
  }

  function adaptiveMatches(ranked, confidence, uncertainLimit) {
    var relevant = ranked.filter(function (item) { return item.score > 0; });
    if (!isLowConfidence(confidence)) return relevant.length ? relevant : ranked;
    if (relevant.length >= 2) return relevant;

    var plausible = ranked.filter(function (item) { return item.adaptiveScore > 0; });
    if (plausible.length) return plausible.slice(0, uncertainLimit);
    return ranked.slice(0, uncertainLimit);
  }

  function searchPageHasNativeProducts() {
    var grid = document.querySelector('#product-grid');
    if (!grid) return false;

    return Boolean(
      grid.querySelector('.ba-search-product-card[data-bca-product-handle], li.grid__item, .card-wrapper')
    );
  }

  function searchPageHasRawTitleMatch(rawValue) {
    var rawTokens = words(rawValue).filter(function (token) {
      return token.length >= 2 && !STOP_WORDS.has(token) && !GENERIC_WORDS.has(token);
    });
    if (!rawTokens.length) return false;

    var cards = Array.from(document.querySelectorAll('#product-grid .ba-search-product-card'));
    return cards.some(function (card) {
      var heading = card.querySelector('.card__heading');
      var title = normalize(heading ? heading.textContent : '');
      var titleWords = words(title);

      return rawTokens.every(function (token) {
        return title.indexOf(token) !== -1 || titleWords.some(function (word) {
          return word.indexOf(token) === 0;
        });
      });
    });
  }

  function submitHandler(event) {
    var form = event.target;
    if (!form || !form.matches('form')) return;
    var q = form.querySelector('input[name="q"]');
    if (!q) return;

    var action = normalize(form.getAttribute('action') || '');
    if (action && action.indexOf('search') === -1 && form.getAttribute('role') !== 'search') return;

    var resolved = resolveQuery(q.value);
    if (!resolved.query) return;
    prepareForm(form);
    if (resolved.optimized && !requiresNativeValidation(resolved) && (!resolved.changed || (resolved.reasons || []).every(function(reason){return reason === 'alias' || reason === 'exact';}))) {
      ensureHidden(form, 'bca_smart', '1');
      ensureHidden(form, 'bca_original', q.value.trim());
      if (resolved.notice) ensureHidden(form, 'bca_notice', '1');
      q.value = resolved.query;
    }
  }

  function redirectSearchPage() {
    if (window.location.pathname.replace(/\/+$/, '') !== '/search') return false;
    var params = new URLSearchParams(window.location.search);
    if (params.get('bca_smart') === '1') return false;
    var q = params.get('q');
    if (!q) return false;
    var resolved = resolveQuery(q);
    if (searchPageHasNativeProducts()) {
      if (!resolved.optimized || resolved.query === normalize(q) || searchPageHasRawTitleMatch(q)) return false;
    }
    if (!resolved.optimized || resolved.query === normalize(q)) return false;
    window.location.replace(searchUrl(resolved.query, q, resolved.notice));
    return true;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#039;' }[character];
    });
  }

  function requestNativeResults(input, resolved) {
    var predictiveSearch = input.closest('predictive-search');
    var nativeQuery = requiresNativeValidation(resolved) ? resolved.raw : resolved.query;
    if (
      !nativeQuery ||
      !predictiveSearch ||
      typeof predictiveSearch.getSearchResults !== 'function'
    ) {
      return;
    }

    var requestKey = resolved.raw + '>' + nativeQuery;
    if (
      predictiveSearch.dataset.bcaRequestKey === requestKey &&
      predictiveSearch.hasAttribute('results')
    ) {
      if (typeof predictiveSearch.open === 'function') predictiveSearch.open();
      return;
    }

    predictiveSearch.dataset.bcaRequestKey = requestKey;
    if (nativeQuery !== resolved.raw) {
      predictiveSearch.dataset.bcaCorrectedQuery = nativeQuery;
    } else {
      delete predictiveSearch.dataset.bcaCorrectedQuery;
    }

    predictiveSearch.searchTerm = nativeQuery;
    if (Array.isArray(resolved.alternatives) && resolved.alternatives.length > 1) {
      loadCombinedPredictiveResults(predictiveSearch, resolved);
      return;
    }
    predictiveSearch.getSearchResults(nativeQuery);
    window.setTimeout(function () {
      filterPredictiveResults(predictiveSearch, resolveQuery(input.value));
    }, 360);
    window.setTimeout(function () {
      filterPredictiveResults(predictiveSearch, resolveQuery(input.value));
    }, 900);
  }

  function productHandleFromUrl(value) {
    if (!value) return '';

    try {
      var pathname = new URL(value, window.location.origin).pathname;
      var marker = '/products/';
      var position = pathname.indexOf(marker);
      if (position === -1) return '';
      return decodeURIComponent(pathname.slice(position + marker.length).split('/')[0]);
    } catch (error) {
      return '';
    }
  }

  function preparedFromElement(element, handle) {
    var heading = element.querySelector('.card__heading, .bac-ps-product-title, .predictive-search__item-heading');
    var source = element.getAttribute('aria-label') || (heading ? heading.textContent : element.textContent) || '';
    var title = normalize(source.split(/,\s*incluye/i)[0]);

    return {
      product: { h: handle || '', t: title, y: '' },
      title: title,
      type: '',
      tags: '',
      titleWords: words(title),
      tagWords: []
    };
  }

  function clearAdaptivePredictiveResults(predictiveSearch) {
    if (!predictiveSearch) return;

    var adaptive = predictiveSearch.querySelector(':scope > [data-bca-adaptive-results]');
    if (!adaptive) {
      adaptive = predictiveSearch.nextElementSibling;
      if (!adaptive || !adaptive.hasAttribute('data-bca-adaptive-results')) adaptive = null;
    }
    if (adaptive) adaptive.remove();

    var nativeResults = predictiveSearch.querySelector('[data-bca-native-results], #predictive-search-results-native, #predictive-search-results');
    if (nativeResults) {
      nativeResults.id = 'predictive-search-results';
      nativeResults.hidden = false;
      nativeResults.style.removeProperty('display');
      nativeResults.removeAttribute('data-bca-native-results');
    }
  }

  function hideNativePredictiveResults(predictiveSearch) {
    var nativeResults = Array.from(
      predictiveSearch.querySelectorAll('#predictive-search-results, [data-bca-native-results], #predictive-search-results-native, [data-predictive-search]')
    ).find(function (element) {
      return !element.hasAttribute('data-bca-adaptive-results');
    });
    if (!nativeResults) return null;

    nativeResults.id = 'predictive-search-results-native';
    nativeResults.setAttribute('data-bca-native-results', 'true');
    nativeResults.hidden = true;
    nativeResults.style.setProperty('display', 'none', 'important');
    return nativeResults;
  }

  function adaptivePredictiveResults(predictiveSearch) {
    var child = predictiveSearch.querySelector(':scope > [data-bca-adaptive-results]');
    if (child) return child;

    var sibling = predictiveSearch.nextElementSibling;
    if (sibling && sibling.hasAttribute('data-bca-adaptive-results')) return sibling;
    return null;
  }

  function positionAdaptivePredictiveResults(predictiveSearch, adaptiveResults) {
    if (!predictiveSearch || !adaptiveResults) return;

    var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var predictiveRect = predictiveSearch.getBoundingClientRect();
    var availableHeight = Math.max(140, Math.floor(viewportHeight - predictiveRect.bottom - 12));

    adaptiveResults.style.setProperty('position', 'absolute', 'important');
    adaptiveResults.style.setProperty('top', '100%', 'important');
    adaptiveResults.style.setProperty('left', '0', 'important');
    adaptiveResults.style.setProperty('right', '0', 'important');
    adaptiveResults.style.setProperty('width', '100%', 'important');
    adaptiveResults.style.setProperty('height', 'auto', 'important');
    adaptiveResults.style.setProperty('max-height', availableHeight + 'px', 'important');
    adaptiveResults.style.setProperty('overflow-x', 'hidden', 'important');
    adaptiveResults.style.setProperty('overflow-y', 'auto', 'important');
    adaptiveResults.style.setProperty('overscroll-behavior', 'contain', 'important');
    adaptiveResults.style.setProperty('z-index', '6', 'important');
  }

  function bindAdaptivePredictiveResize(predictiveSearch) {
    if (!predictiveSearch || predictiveSearch.dataset.bcaAdaptiveResize === 'true') return;
    predictiveSearch.dataset.bcaAdaptiveResize = 'true';

    var reposition = function () {
      var adaptiveResults = adaptivePredictiveResults(predictiveSearch);
      if (adaptiveResults) positionAdaptivePredictiveResults(predictiveSearch, adaptiveResults);
    };

    window.addEventListener('resize', reposition, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', reposition, { passive: true });
      window.visualViewport.addEventListener('scroll', reposition, { passive: true });
    }
  }

  function predictiveSource(query) {
    var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var endpoint = routesRoot + 'search/suggest?q=' + encodeURIComponent(query) + '&section_id=predictive-search';

    return fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Predictive search error ' + response.status);
        return response.text();
      })
      .then(function (markup) {
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var source = parsed.querySelector('#predictive-search-results');
        var section = parsed.querySelector('#shopify-section-predictive-search');
        if (!source) return null;

        if (section) {
          Array.from(section.querySelectorAll(':scope > style')).reverse().forEach(function (style) {
            source.insertBefore(style.cloneNode(true), source.firstChild);
          });
        }

        return source;
      });
  }

  function renderInNativePredictiveResults(predictiveSearch, source, input) {
    if (!predictiveSearch || !source) return false;

    clearAdaptivePredictiveResults(predictiveSearch);
    var target = predictiveSearch.predictiveSearchResults || predictiveSearch.querySelector('[data-predictive-search]');
    if (!target) return false;

    target.hidden = false;
    target.style.removeProperty('display');
    target.removeAttribute('data-bca-native-results');

    if (typeof predictiveSearch.renderSearchResults === 'function') {
      predictiveSearch.renderSearchResults(source.outerHTML);
    } else {
      target.innerHTML = source.outerHTML;
      predictiveSearch.setAttribute('results', 'true');
      predictiveSearch.setAttribute('open', 'true');
    }

    if (input) input.setAttribute('aria-expanded', 'true');
    return true;
  }

  function loadCombinedPredictiveResults(predictiveSearch, resolved) {
    var input = predictiveSearch.querySelector('input[name="q"]');
    var target = predictiveSearch.querySelector('[data-predictive-search], #predictive-search-results, [data-bca-native-results], #predictive-search-results-native');
    if (!input || !target || !resolved || !resolved.raw) return false;

    var queries = [resolved.raw].concat(resolved.alternatives || []).filter(function (query, index, all) {
      return query && all.indexOf(query) === index;
    }).slice(0, 4);

    predictiveSearch.dataset.bcaCorrectionState = 'combining';
    if (typeof predictiveSearch.setLiveRegionLoadingState === 'function') {
      predictiveSearch.setLiveRegionLoadingState();
    }

    Promise.all(queries.map(predictiveSource))
      .then(function (sources) {
        if (normalize(input.value) !== resolved.raw) return;

        var source = sources[0];
        if (!source) throw new Error('Predictive search markup missing');

        var firstItem = source.querySelector('a[href*="/products/"]');
        var list = firstItem ? firstItem.closest('li[role="option"]')?.parentElement : null;
        var seenHandles = new Set();

        Array.from(source.querySelectorAll('a[href*="/products/"]')).forEach(function (link) {
          seenHandles.add(productHandleFromUrl(link.getAttribute('href')));
        });

        sources.slice(1).forEach(function (candidateSource) {
          if (!candidateSource || !list || seenHandles.size >= 8) return;

          Array.from(candidateSource.querySelectorAll('a[href*="/products/"]')).some(function (link) {
            if (seenHandles.size >= 8) return true;
            var handle = productHandleFromUrl(link.getAttribute('href'));
            var item = link.closest('li[role="option"]');
            if (!handle || !item || seenHandles.has(handle)) return false;

            var clone = item.cloneNode(true);
            clone.id = 'bca-combined-product-' + (seenHandles.size + 1);
            list.appendChild(clone);
            seenHandles.add(handle);
            return seenHandles.size >= 8;
          });
        });

        if (!renderInNativePredictiveResults(predictiveSearch, source, input)) {
          throw new Error('Native predictive search container missing');
        }
        predictiveSearch.dataset.bcaCorrectionState = 'combined';
        delete predictiveSearch.dataset.bcaPrecisionFilterKey;
        filterPredictiveResults(predictiveSearch, resolved);
      })
      .catch(function () {
        predictiveSearch.dataset.bcaCorrectionState = 'combine-error';
        predictiveSearch.getSearchResults(resolved.raw);
      });

    return true;
  }

  function loadCorrectedPredictiveResults(predictiveSearch, resolved) {
    var target = predictiveSearch.predictiveSearchResults || predictiveSearch.querySelector('[data-predictive-search]');
    var input = predictiveSearch.querySelector('input[name="q"]');
    if (!target || !input || !resolved || !resolved.query) return false;

    predictiveSearch.dataset.bcaCorrectionState = 'loading';

    predictiveSource(resolved.query)
      .then(function (source) {
        if (normalize(input.value) !== resolved.raw) {
          predictiveSearch.dataset.bcaCorrectionState = 'discarded';
          return;
        }
        if (!source) {
          predictiveSearch.dataset.bcaCorrectionState = 'missing';
          return;
        }

        if (!renderInNativePredictiveResults(predictiveSearch, source, input)) {
          throw new Error('Native predictive search container missing');
        }
        predictiveSearch.dataset.bcaCorrectionState = 'loaded';
        delete predictiveSearch.dataset.bcaPrecisionFilterKey;
        filterPredictiveResults(predictiveSearch, resolved);
      })
      .catch(function (error) {
        predictiveSearch.dataset.bcaCorrectionState = 'error:' + String(error && error.message ? error.message : error);
        var nativeResults = predictiveSearch.querySelector('[data-bca-native-results], #predictive-search-results-native');
        if (nativeResults) {
          nativeResults.id = 'predictive-search-results';
          nativeResults.hidden = false;
          nativeResults.style.removeProperty('display');
          nativeResults.removeAttribute('data-bca-native-results');
        }
      });

    return true;
  }

  function requestCorrectedPredictiveFallback(predictiveSearch, resolved) {
    if (
      !resolved ||
      resolved.query === resolved.raw ||
      !predictiveSearch.hasAttribute('results')
    ) {
      return false;
    }

    var fallbackKey = resolved.raw + '>' + resolved.query;
    if (predictiveSearch.dataset.bcaCorrectionFallbackKey === fallbackKey) return false;

    predictiveSearch.dataset.bcaCorrectionFallbackKey = fallbackKey;
    delete predictiveSearch.dataset.bcaPrecisionFilterKey;
    predictiveSearch.dataset.bcaCorrectedQuery = resolved.query;
    return loadCorrectedPredictiveResults(predictiveSearch, resolved);
  }

  function filterPredictiveResults(predictiveSearch, resolved) {
    if (!predictiveSearch || !resolved || !resolved.query) return;

    var resultRoot = adaptivePredictiveResults(predictiveSearch) || predictiveSearch;
    if (resultRoot !== predictiveSearch) {
      hideNativePredictiveResults(predictiveSearch);
      positionAdaptivePredictiveResults(predictiveSearch, resultRoot);
    }
    var links = Array.from(resultRoot.querySelectorAll('.bac-ps-product-link[href*="/products/"]'));
    if (!links.length) {
      requestCorrectedPredictiveFallback(predictiveSearch, resolved);
      return;
    }
    if (!predictiveSearch.hasAttribute('results')) return;

    var adaptiveFallbackKey = resolved.raw + '>' + resolved.query;
    if (
      isLowConfidence(resolved) &&
      resolved.query !== resolved.raw &&
      predictiveSearch.dataset.bcaCorrectionFallbackKey !== adaptiveFallbackKey
    ) {
      predictiveSearch.dataset.bcaCorrectionFallbackKey = adaptiveFallbackKey;
      delete predictiveSearch.dataset.bcaPrecisionFilterKey;
      predictiveSearch.dataset.bcaCorrectedQuery = resolved.query;
      loadCorrectedPredictiveResults(predictiveSearch, resolved);
      return;
    }

    var filterKey = resolved.raw + '>' + resolved.query + '>' + links.length;
    if (predictiveSearch.dataset.bcaPrecisionFilterKey === filterKey) return;
    predictiveSearch.dataset.bcaPrecisionFilterKey = filterKey;

    var ranked = links.map(function (link, index) {
      var handle = productHandleFromUrl(link.getAttribute('href'));
      var prepared = PREPARED_BY_HANDLE.get(handle) || preparedFromElement(link, handle);
      var strictScore = scorePrepared(prepared, resolved);
      return {
        item: link.closest('li[role="option"]') || link,
        index: index,
        score: strictScore,
        adaptiveScore: scorePreparedLoose(prepared, resolved, strictScore)
      };
    }).sort(function (a, b) {
      if (isLowConfidence(resolved)) {
        return b.adaptiveScore - a.adaptiveScore || b.score - a.score || a.index - b.index;
      }
      return b.score - a.score || a.index - b.index;
    });

    var relevant = ranked.filter(function (item) { return item.score > 0; });
    if (!relevant.length && requestCorrectedPredictiveFallback(predictiveSearch, resolved)) return;

    var visible = adaptiveMatches(ranked, resolved, 5);
    if (!visible.length) return;
    var visibleItems = new Set(visible.map(function (item) { return item.item; }));

    ranked.forEach(function (item) {
      var shouldShow = visibleItems.has(item.item);
      item.item.hidden = !shouldShow;
      if (shouldShow) item.item.style.removeProperty('display');
      else item.item.style.setProperty('display', 'none', 'important');
    });

    var list = visible[0].item.parentElement;
    visible.forEach(function (item) {
      if (list && item.item.parentElement === list) list.appendChild(item.item);
    });

    var total = visible.length;
    var section = list ? list.parentElement : null;
    var heading = section ? section.querySelector('.bac-ps-results-title') : null;
    if (heading) heading.textContent = 'Productos encontrados (' + total + ')';

    if (section) {
      [section].concat(Array.from(section.querySelectorAll('[aria-label]'))).forEach(function (element) {
        if (/productos encontrados/i.test(element.getAttribute('aria-label') || '')) {
          element.setAttribute('aria-label', 'Productos encontrados (' + total + ')');
        }
      });
    }

    predictiveSearch.querySelectorAll('[data-total-results]').forEach(function (element) {
      element.dataset.totalResults = String(total);
    });

    predictiveSearch.querySelectorAll('[role="status"]').forEach(function (status) {
      status.textContent = total + (total === 1 ? ' resultado: 1 producto' : ' resultados: ' + total + ' productos');
    });
    predictiveSearch.removeAttribute('loading');
  }

  function initSuggestions() {
    document.querySelectorAll('form').forEach(function (form) {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      prepareForm(form);

      var timer;
      var predictiveSearch = input.closest('predictive-search');
      if (predictiveSearch && window.MutationObserver && predictiveSearch.dataset.bcaPrecisionObserver !== 'true') {
        predictiveSearch.dataset.bcaPrecisionObserver = 'true';
        new MutationObserver(function () {
          filterPredictiveResults(predictiveSearch, resolveQuery(input.value));
        }).observe(predictiveSearch, { childList: true, subtree: true });
      }

      function handleNativeSearch(event) {
        var predictiveSearch = input.closest('predictive-search');
        if (!predictiveSearch || typeof predictiveSearch.getSearchResults !== 'function') return;

        event.stopImmediatePropagation();
        window.clearTimeout(timer);

        if (event.type === 'input') {
          clearAdaptivePredictiveResults(predictiveSearch);
          if (typeof predictiveSearch.close === 'function') predictiveSearch.close();
          predictiveSearch.removeAttribute('results');
          delete predictiveSearch.dataset.bcaRequestKey;
          delete predictiveSearch.dataset.bcaPrecisionFilterKey;
          delete predictiveSearch.dataset.bcaCorrectionFallbackKey;
          delete predictiveSearch.dataset.bcaCorrectionState;
          if (typeof predictiveSearch.toggleResetButton === 'function') {
            predictiveSearch.toggleResetButton();
          }
        }

        var resolved = resolveQuery(input.value);
        if (!resolved.query) {
          delete predictiveSearch.dataset.bcaCorrectedQuery;
          if (typeof predictiveSearch.close === 'function') predictiveSearch.close(true);
          return;
        }

        timer = window.setTimeout(function () {
          requestNativeResults(input, resolved);
        }, 80);
      }

      input.addEventListener('input', handleNativeSearch, true);
      input.addEventListener('focus', handleNativeSearch, true);
    });
  }

  function showCorrectionNotice() {
    if (window.location.pathname.replace(/\/+$/, '') !== '/search') return;
    var params = new URLSearchParams(window.location.search);
    if (params.get('bca_notice') !== '1') return;
    var original = params.get('bca_original');
    var corrected = params.get('q');
    if (!original || !corrected || normalize(original) === normalize(corrected)) return;

    var anchor = document.querySelector('#product-grid') || document.querySelector('#main-search-filters') || document.querySelector('.ba-search-count');
    if (!anchor || document.querySelector('.bca-smart-notice')) return;
    var notice = document.createElement('div');
    notice.className = 'bca-smart-notice';
    notice.innerHTML = '<span>Mostrando resultados para</span> <strong>“' + escapeHtml(corrected) + '”</strong>' +
      '<small>Buscaste “' + escapeHtml(original) + '”</small>';
    var insertionTarget = anchor.id === 'product-grid' ? anchor.parentElement : anchor;
    insertionTarget.parentNode.insertBefore(notice, insertionTarget);
  }

  function reorderSearchResults() {
    var grid = document.querySelector('#product-grid');
    if (!grid) return;
    var list = grid.querySelector('ul.product-grid') || grid.querySelector('.product-grid');
    if (!list) return;
    var params = new URLSearchParams(window.location.search);
    var resolved = resolveQuery(params.get('q') || '');
    var confidence = resolveQuery(params.get('bca_original') || params.get('q') || '');
    if (!resolved.query) return;

    var cards = Array.from(grid.querySelectorAll('.ba-search-product-card[data-bca-product-handle]'));
    if (!cards.length) return;

    var rankedCards = cards.map(function (card, index) {
      var handle = card.getAttribute('data-bca-product-handle');
      var prepared = PREPARED_BY_HANDLE.get(handle) || preparedFromElement(card, handle);
      var li = card.closest('li') || card;
      var strictScore = scorePrepared(prepared, resolved);
      return {
        node: li,
        index: index,
        score: strictScore,
        adaptiveScore: scorePreparedLoose(prepared, confidence, strictScore)
      };
    }).sort(function (a, b) {
      if (isLowConfidence(confidence)) {
        return b.adaptiveScore - a.adaptiveScore || b.score - a.score || a.index - b.index;
      }
      return b.score - a.score || a.index - b.index;
    });

    var visibleCards = adaptiveMatches(rankedCards, confidence, 5);
    var visibleNodes = new Set(visibleCards.map(function (item) { return item.node; }));

    rankedCards.forEach(function (item) {
      var shouldShow = visibleNodes.has(item.node);
      item.node.hidden = !shouldShow;
      if (shouldShow) item.node.style.removeProperty('display');
      else item.node.style.setProperty('display', 'none', 'important');
    });

    rankedCards.forEach(function (item) {
      if (item.node.parentElement !== list) list.appendChild(item.node);
    });

    visibleCards.forEach(function (item) { list.appendChild(item.node); });

    var visibleCount = visibleCards.length;
    var countText = visibleCount + (visibleCount === 1 ? ' producto encontrado' : ' productos encontrados');
    document.querySelectorAll('.ba-search-count, #ProductCountDesktop, #ProductCount').forEach(function (element) {
      element.textContent = countText;
    });

    var pagination = document.querySelector('.pagination-wrapper, nav[aria-label="Paginación"]');
    if (pagination) {
      var hasFilteredCards = visibleCards.length < rankedCards.length;
      pagination.hidden = hasFilteredCards;
      if (hasFilteredCards) pagination.style.setProperty('display', 'none', 'important');
      else pagination.style.removeProperty('display');
    }
  }

  function showNoResultFallback() {
    if (window.location.pathname.replace(/\/+$/, '') !== '/search') return;
    var grid = document.querySelector('#product-grid');
    if (grid && grid.children.length) return;
    var params = new URLSearchParams(window.location.search);
    var resolved = resolveQuery(params.get('q') || '');
    var matches = rankProducts(resolved, 6);
    if (!matches.length || document.querySelector('.bca-smart-fallback')) return;

    var host = document.querySelector('main') || document.body;
    var block = document.createElement('section');
    block.className = 'bca-smart-fallback';
    block.innerHTML = '<h2>Prueba estas coincidencias</h2><p>Encontramos productos relacionados aunque la búsqueda no fuera exacta.</p>' +
      '<div>' + matches.map(function (match) {
        return '<a href="/products/' + encodeURIComponent(match.prepared.product.h) + '">' +
          escapeHtml(match.prepared.product.t) + '<span>Ver producto</span></a>';
      }).join('') + '</div>';
    host.appendChild(block);
  }


  // Keep partial names broad ("iron"), but separate incidental references
  // once every word identifies a design ("iron maiden"). No stale catalogue
  // entries are rendered: cards always come from Shopify's current response.
  function titleMatchesQuery(title, query) {
    var singular = function (word) {
      return {camisetas:'camiseta',cobijas:'cobija',disenos:'diseno'}[word] || word;
    };
    var tokens = words(query).filter(function (w) { return !STOP_WORDS.has(w); }).map(singular);
    var titleTokens = words(title).map(singular);
    return tokens.length > 0 && tokens.every(function (token) {
      return titleTokens.some(function (word) { return word.indexOf(token) === 0; });
    });
  }

  function refineSearchResults() {
    var grid = document.querySelector('#product-grid');
    if (!grid || grid.dataset.bcaRefined === 'true') return;
    var query = new URLSearchParams(window.location.search).get('q') || '';
    var cards = Array.from(grid.querySelectorAll('.ba-search-product-card[data-bca-product-handle]'));
    if (!cards.length || !query) return;
    grid.dataset.bcaRefined = 'true';
    var matches = cards.filter(function(card) {
      // Handles preserve product type even when the visual heading omits it.
      return titleMatchesQuery(card.getAttribute('data-bca-product-handle') || '', query);
    });
    if (!matches.length || matches.length === cards.length) return;
    var secondary = cards.filter(function(card) { return !matches.includes(card); });
    secondary.forEach(function(card) { var node=card.closest('li') || card; node.hidden = true; node.style.setProperty('display','none','important'); });
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--secondary bca-related-toggle';
    button.setAttribute('aria-expanded','false');
    button.style.cssText = 'display:block;margin:20px auto;white-space:normal;';
    var update = function(expanded) {
      button.textContent = expanded ? 'Mostrar solo coincidencias principales' : 'Ver otras coincidencias (' + secondary.length + ')';
      document.querySelectorAll('.ba-search-count, #ProductCountDesktop, #ProductCount').forEach(function(el) {
        el.textContent = matches.length + ' coincidencias principales' + (document.querySelector('.pagination-wrapper') ? ' en esta página' : '') + (expanded ? ' · ' + secondary.length + ' adicionales' : '');
      });
    };
    button.addEventListener('click',function() {
      var expanded = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded',String(expanded));
      secondary.forEach(function(card) { var node=card.closest('li') || card; node.hidden = !expanded; if(expanded) node.style.removeProperty('display'); else node.style.setProperty('display','none','important'); });
      update(expanded);
    });
    grid.appendChild(button);
    update(false);
  }

  function finishRenderLock() {
    document.documentElement.classList.remove('bca-search-render-lock');
  }

  function init() {
    if(document.querySelector('[data-bca-search-page]')) { finishRenderLock(); return; }
    // Preserve the customer's original name; live catalog validation happens asynchronously.
    document.addEventListener('submit', submitHandler, true);

    showCorrectionNotice();

    refineSearchResults();
    var resultHost = document.querySelector('#ProductGridContainer');
    if (resultHost) new MutationObserver(refineSearchResults).observe(resultHost, {childList:true,subtree:true});
    document.documentElement.classList.add('bca-smart-search-ready');
    finishRenderLock();
  }

  window.BCASmartSearch = {
    normalize: normalize,
    resolveQuery: resolveQuery,
    rankProducts: rankProducts,
    titleMatchesQuery: titleMatchesQuery,
    updateCatalog: updateCatalog,
    version: '2026-09-30-live-catalog'
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

/* BCA_LIVE_CATALOG_BUNDLE */
(function () {
  'use strict';
  var products = [];
  var refreshed = 0;
  var pending = null;
  var preview = [];
  var previewAt = 0;
  var listeners = new Set();
  var pageEnhancing = false;
  var TTL = 60000;
  var fallbackStyles = "<style>#predictive-search-results .bac-ps-products{list-style:none;padding:0;margin:0;display:grid;gap:12px}#predictive-search-results .bac-ps-product-link{display:grid;grid-template-columns:90px minmax(0,1fr);gap:14px;padding:12px;color:#fff;text-decoration:none;border:1px solid #30596b;border-radius:14px;background:#0a1722}#predictive-search-results .bac-ps-product-image{width:100%;height:auto;border-radius:10px}#predictive-search-results .bac-ps-product-title{font-weight:700;font-size:16px;line-height:1.3;margin:0 0 8px}#predictive-search-results .bac-ps-product-hint{font-size:13px;line-height:1.4;color:#d7e9ef}#predictive-search-results .bac-ps-design-badge{color:#90ffce;font-size:13px}#predictive-search-results .bac-ps-card-arrow{display:none}#predictive-search-results .bac-ps-results-title{font-size:17px;color:#fff}#predictive-search-results .bac-ps-search-link{display:block;padding:16px;color:#90ffce}#predictive-search-results{background:#08121d;padding:14px}</style>";
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var queryCache = new Map();
  var requests = new Map();
  TTL = 300000;
  function notify() { listeners.forEach(function(listener){try{listener();}catch(error){}}); }
  function escape(value) { return String(value || '').replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function productUrl(product) { return root + 'products/' + encodeURIComponent(product.h); }
  function requestedQuery(query) {
    if (typeof query === 'string') return query.trim();
    var focused = document.activeElement;
    if (focused && focused.matches('input[name="q"]') && focused.value.trim()) return focused.value.trim();
    var open = Array.from(document.querySelectorAll('input[name="q"]')).find(function(input){return input.value.trim() && input.getBoundingClientRect().width > 0;});
    return open ? open.value.trim() : new URLSearchParams(location.search).get('q') || '';
  }
  function resolvedQuery(query) {
    var broad=String(query||'').replace(/\b(camisetas?|cobijas?|mantas?)\b/gi,' ').replace(/\s+/g,' ').trim();
    var base=broad||query;
    var result = window.BCASmartSearch && window.BCASmartSearch.resolveQuery(base);
    var value = result && result.changed ? result.query : base;
    if (/^ac[\s/]*dc$/i.test(value)) value = 'ACDC';
    return value;
  }
  function queryKey(query) { return String(resolvedQuery(query)).toLocaleLowerCase().replace(/\s+/g,' ').trim(); }
  function cached(query) {
    var key=queryKey(query), entry=queryCache.get(key);
    if (!entry) { try { entry=JSON.parse(sessionStorage.getItem('bca-search-query-v3-'+encodeURIComponent(key)) || 'null'); } catch(error) { } }
    if (entry && Date.now()-entry.at>=0 && Date.now()-entry.at<TTL) { queryCache.set(key,entry); return entry; }
    return null;
  }
  async function refresh(query) {
    query=requestedQuery(query); if(!query)return [];
    var key=queryKey(query), saved=cached(query);if(saved){products=saved.products;refreshed=saved.at;return saved.products;}
    if(requests.has(key))return requests.get(key);
    var task=(async function(){
      var controller=new AbortController(),timeout=setTimeout(function(){controller.abort();},30000);
      try {
        async function page(number) {
          var params=new URLSearchParams({view:'bca-search-catalog',q:resolvedQuery(query),type:'product','options[prefix]':'last',page:String(number),bca_revision:'units3-'+String(Math.floor(Date.now()/TTL))});
          var response=await fetch(root+'search?'+params,{signal:controller.signal,headers:{Accept:'text/html'}});
          if(!response.ok)throw Error('SEARCH_UNAVAILABLE');
          var data=await response.json();if(data.version!==3||!Array.isArray(data.products)||!Number.isInteger(data.pages))throw Error('SEARCH_INVALID');return data;
        }
        var first=await page(1),chunks=[first.products],next=2;
        async function worker(){while(next<=first.pages){var index=next++,batch=await page(index);if(batch.pages!==first.pages||batch.total!==first.total)throw Error('SEARCH_CHANGED');chunks[index-1]=batch.products;}}
        await Promise.all([worker(),worker(),worker()]);
        var seen=new Map();chunks.flat().forEach(function(p){if(p&&typeof p.h==='string'&&typeof p.t==='string'&&/^[a-z0-9][a-z0-9-]*$/.test(p.h))seen.set(p.h,p);});
        var found=Array.from(seen.values()),entry={at:Date.now(),products:found};queryCache.set(key,entry);products=found;refreshed=entry.at;
        try{sessionStorage.setItem('bca-search-query-v3-'+encodeURIComponent(key),JSON.stringify(entry));}catch(error){}
        notify();return found;
      }finally{clearTimeout(timeout);}
    }()).finally(function(){requests.delete(key);});requests.set(key,task);return task;
  }
  function matches(query) {
    var entry=cached(query);if(!entry)return [];
    var smart=window.BCASmartSearch,resolved=smart&&smart.resolveQuery(query);
    var broad=resolvedQuery(query);
    var broadResolved=smart&&smart.resolveQuery(broad);
    var term=broadResolved?broadResolved.query:broad;
    var exact=smart?entry.products.filter(function(p){return smart.titleMatchesQuery(p.t+' '+(p.g||[]).join(' ')+' '+p.y,term);}):entry.products;
    var found=exact.length?exact:entry.products;
    var ordered=found.slice().sort(function(a,b){return Number(b.a)-Number(a.a)||a.t.localeCompare(b.t);});
    var blankets=ordered.filter(function(p){return /cobija/i.test(p.y||p.t);}),shirts=ordered.filter(function(p){return !/cobija/i.test(p.y||p.t);}),ranked=[];
    while(blankets.length||shirts.length){if(blankets.length)ranked.push(blankets.shift());if(blankets.length)ranked.push(blankets.shift());if(shirts.length)ranked.push(shirts.shift());}return ranked;
  }
  function predictiveMarkup(list, query, nativeStyles) {
    var all = root+'search?'+new URLSearchParams({q:query,type:'product','options[prefix]':'last'});
    var groups = new Map();
    list.forEach(function(product){
      var type=window.BCASmartSearch.normalize(product.y) || 'producto';
      if(!groups.has(type))groups.set(type,[]);
      groups.get(type).push(product);
    });
    var shown=list.slice(0,16);
    return (nativeStyles || fallbackStyles)+'<div id="predictive-search-results" role="listbox" data-bac-search-term="'+escape(query)+'"><section><h2 class="bac-ps-results-title">Estampados encontrados: '+list.length+(shown.length<list.length?' · mostrando '+shown.length:'')+'</h2><ul class="bca-predictive-cards" role="group">'+shown.map(function(p,index){
      return '<li id="predictive-search-option-live-'+index+'" role="option" aria-selected="false" class="bca-predictive-card" data-bca-predictive-handle="'+escape(p.h)+'" data-bca-predictive-variant="'+escape(p.v||'')+'" data-bac-searchable="'+escape(p.t)+'"><a class="bca-predictive-placeholder" href="'+escape(productUrl(p))+'">'+(p.i?'<img src="'+escape(p.i)+'" alt="'+escape(p.t)+'" width="320" height="400" loading="lazy">':'')+'<strong>'+escape(p.t)+'</strong><span>Cargando tallas y tamaños…</span></a></li>';
    }).join('')+'</ul></section><a class="bac-ps-search-link" href="'+root+'collections/todas-las-cobijas">◇ Tu fandom también abriga · Ver cobijas →</a><a class="bac-ps-search-link" href="'+escape(all)+'">Ver los '+list.length+' estampados de “'+escape(query)+'” →</a><span class="visually-hidden" data-total-results="'+list.length+'" data-predictive-search-live-region-count-value>'+list.length+' productos encontrados</span></div>';
  }
  var predictiveCards=new Map();
  function hydratePredictiveCards(){
    document.querySelectorAll('[data-bca-predictive-handle]:not([data-bca-card-loading])').forEach(function(host){
      host.dataset.bcaCardLoading='true';var handle=host.dataset.bcaPredictiveHandle;
      var variant=host.dataset.bcaPredictiveVariant,cardKey=handle+':'+(variant||'');
      var request=predictiveCards.get(cardKey);
      if(!request){
        request=fetch(root+'products/'+encodeURIComponent(handle)+'?view=bca-search-card'+(variant?'&variant='+encodeURIComponent(variant):''),{credentials:'same-origin'}).then(function(response){if(!response.ok)throw Error('CARD_UNAVAILABLE');return response.text();}).then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html'),card=doc.querySelector('[data-bca-live-card]');
          if(!card)throw Error('CARD_UNAVAILABLE');return card.innerHTML;
        });
        predictiveCards.set(cardKey,request);request.catch(function(){predictiveCards.delete(cardKey);});
      }
      request.then(function(html){if(host.isConnected)host.innerHTML=html;}).catch(function(){if(host.isConnected){var hint=host.querySelector('span');if(hint)hint.textContent='Ver opciones →';}});
    });
  }
  var predictiveScheduled=false;
  new MutationObserver(function(records){
    if(predictiveScheduled||!records.some(function(record){return record.addedNodes.length;}))return;
    predictiveScheduled=true;requestAnimationFrame(function(){predictiveScheduled=false;hydratePredictiveCards();});
  }).observe(document.documentElement,{childList:true,subtree:true});
  async function enhancePage() {
    if(document.querySelector('[data-bca-search-page]')) return;
    if (pageEnhancing) return;
    if (!/\/search\/?$/.test(window.location.pathname)) return;
    var params = new URLSearchParams(window.location.search);
    if (Array.from(params.keys()).some(function(key){return /^filter\./.test(key);})) return;
    var query = params.get('bca_original') || params.get('q') || '';
    if (!query) return;
    pageEnhancing = true;
    try {
      await refresh(query);
      var found = matches(query);
      if (!found.length) return;
      var grid = document.querySelector('#product-grid');
      if (!grid) return;
      var existing = new Set(Array.from(grid.querySelectorAll('[data-bca-product-handle]')).map(function(card){return card.dataset.bcaProductHandle;}));
      var missing = found.filter(function(p){return !existing.has(p.h);});
      if (!missing.length) return;
      var host = document.createElement('section');
      host.className = 'bca-live-search-results';
      host.innerHTML = '<h2 class="h2">Más coincidencias del catálogo actual</h2><ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop" role="list"></ul>';
      grid.prepend(host);
      var list = host.querySelector('ul');
      var offset = 0;
      var more = document.createElement('button');
      more.className='button button--secondary';more.type='button';more.textContent='Ver más productos';
      async function append() {
        more.disabled=true;
        var batch=missing.slice(offset,offset+12);
        var rendered=await Promise.all(batch.map(async function(p){
          try { var response=await fetch(productUrl(p)+'?view=bca-search-card');if(!response.ok)return null;
            var doc=new DOMParser().parseFromString(await response.text(),'text/html');return doc.querySelector('[data-bca-live-card]');
          } catch(error){return null;}
        }));
        rendered.filter(Boolean).forEach(function(card){list.appendChild(card);});
        offset+=batch.length; more.disabled=false;more.hidden=offset>=missing.length;
        if(more.hidden)more.style.setProperty('display','none','important');else more.style.removeProperty('display');
      }
      more.addEventListener('click',append);host.appendChild(more);await append();
      if(!list.children.length){host.remove();return;}
      var handles=new Set(found.map(function(p){return p.h;}));
      var secondary=Array.from(grid.querySelectorAll('[data-bca-product-handle]')).filter(function(card){return !handles.has(card.dataset.bcaProductHandle);});
      if(secondary.length){
        secondary.forEach(function(card){var item=card.closest('li') || card;item.hidden=true;item.style.setProperty('display','none','important');});
        var related=document.createElement('button');related.className='button button--secondary';related.type='button';related.textContent='Ver otras coincidencias ('+secondary.length+')';related.setAttribute('aria-expanded','false');
        related.addEventListener('click',function(){var open=related.getAttribute('aria-expanded')!=='true';related.setAttribute('aria-expanded',String(open));secondary.forEach(function(card){var item=card.closest('li')||card;item.hidden=!open;if(open)item.style.removeProperty('display');else item.style.setProperty('display','none','important');});});
        grid.appendChild(related);
      }
      document.querySelectorAll('#main-search-filters, .facets-vertical-sort').forEach(function(el){el.hidden=true;el.style.setProperty('display','none','important');});
      var searchRoot=grid.closest('[id^="bca-main-search-"]');
      if(searchRoot){
        searchRoot.classList.add('bca-live-search-mode');
        if(!searchRoot.querySelector('[data-bca-live-filter-style]')){
          var filterStyle=document.createElement('style');filterStyle.setAttribute('data-bca-live-filter-style','');
          var selector='#'+searchRoot.id.replace(/[^a-zA-Z0-9_-]/g,'')+'.bca-live-search-mode';
          filterStyle.textContent=selector+' #main-search-filters,'+selector+' .facets-vertical-sort{display:none!important;}'+selector+' #main-search-filters::before,'+selector+' #main-search-filters::after{content:none!important;display:none!important;}';
          searchRoot.appendChild(filterStyle);
        }
      }
      if(secondary.length === existing.size)host.querySelector('h2').textContent='Productos encontrados';
      document.querySelectorAll('.ba-search-count, #ProductCountDesktop, #ProductCount').forEach(function(el){el.textContent=found.length+' productos encontrados';});
      document.querySelectorAll('.ba-native-no-results,[data-bca-predictive-fallback]').forEach(function(el){el.hidden=true;el.style.setProperty('display','none','important');});
      grid.querySelectorAll('.collection--empty .title-wrapper').forEach(function(el){el.hidden=true;});
    } catch(error) { } finally { pageEnhancing = false; }
  }
  window.BCALiveCatalog={refresh:refresh,matches:matches,predictiveMarkup:predictiveMarkup,subscribe:function(listener){listeners.add(listener);return function(){listeners.delete(listener);};},version:'2026-10-24-query-catalog',get refreshed(){return refreshed;}};
  listeners.add(function(){if(refreshed && Date.now()-refreshed<TTL && /\/search\/?$/.test(window.location.pathname))setTimeout(enhancePage,0);});
  document.addEventListener('focusin',function(event){if(event.target && event.target.matches('input[name="q"]'))refresh().catch(function(){});});
  var queryTimer;document.addEventListener('input',function(event){if(event.target && event.target.matches('input[name="q"]')){clearTimeout(queryTimer);var query=event.target.value;queryTimer=setTimeout(function(){refresh(query).catch(function(){});},220);}});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhancePage);else enhancePage();
}());

